import { Component } from '@angular/core';

@Component({
  selector: 'dl-select-placeholder',
  templateUrl: './select-placeholder.component.html',
  styleUrls: ['./select-placeholder.component.css'],
})
export class DlSelectPlaceholderComponent {}
